import { useEffect, useState } from 'react';

const DESKTOP_BREAKPOINT = 1024;
const LARGE_DESKTOP_BREAKPOINT = 1280;
const TABLET_BREAKPOINT = 768;

const getWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 0);

export const useScreenWidth = () => {
  const [width, setWidth] = useState<number>(getWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    width,
    isDesktop: width >= DESKTOP_BREAKPOINT,
    isLargeDesktop: width >= LARGE_DESKTOP_BREAKPOINT,
    isTablet: width >= TABLET_BREAKPOINT,
  };
};
